import placeholderImage from '../images/placeholder.webp';
import { useState } from 'react';

const SponsorCard = ({ sponsor, onRemove, preview = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className={`sponsor-card ${preview ? 'is-preview' : ''}`}>
            <div className="sponsor-card-title">
                {sponsor.type == 'Banner' ? (
                    <img src={sponsor.mediaUrl ? process.env.REACT_APP_MEDIA_URL + sponsor.mediaUrl : placeholderImage} alt={sponsor.name} />
                ) : (
                    <video src={process.env.REACT_APP_MEDIA_URL + sponsor.mediaUrl} controls />
                )}
                <div className="sponsor-info">
                    <div className="sponsor-name text-snippet snippet-1">{sponsor.name}</div>
                    {!preview && !!sponsor.code && <div className="sponsor-code"><span>Code:</span> {sponsor.code}</div>}
                </div>
                {!preview && (
                    <div className="sponsor-buttons">
                        <a role="button" onClick={() => setIsOpen(!isOpen)} className="sponsor-open-close">{isOpen ? '-' : '+'}</a>
                        {onRemove ? (
                            <button className="sponsor-remove" onClick={() => onRemove(sponsor.id)}>
                                {'\u00D7'}
                            </button>
                        ) : null}
                    </div>
                )}
            </div>
            {!preview && (
                <div className={`sponsor-card-body-container ${isOpen ? 'is-open' : ''}`}>
                    <div className="sponsor-card-body">
                        {sponsor.type == 'Banner' ? (
                            <img src={sponsor.mediaUrl ? process.env.REACT_APP_MEDIA_URL + sponsor.mediaUrl : placeholderImage} alt={sponsor.name} />
                        ) : (
                            <video src={process.env.REACT_APP_MEDIA_URL + sponsor.mediaUrl} controls />
                        )}
                        <div className="sponsor-label">
                            Affiliate Link
                        </div>

                        <div className="sponsor-link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <g clip-path="url(#clip0_623_1016)">
                                    <path d="M5.99525 10.9905C8.75405 10.9905 10.9905 8.75405 10.9905 5.99525C10.9905 3.23645 8.75405 1 5.99525 1C3.23645 1 1 3.23645 1 5.99525C1 8.75405 3.23645 10.9905 5.99525 10.9905Z" stroke="#99A1AF" stroke-width="0.99905" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M3.99609 5.99525C3.99609 4.13539 4.71153 2.3468 5.99419 1C7.27686 2.3468 7.99229 4.13539 7.99229 5.99525C7.99229 7.85511 7.27686 9.6437 5.99419 10.9905C4.71153 9.6437 3.99609 7.85511 3.99609 5.99525Z" stroke="#99A1AF" stroke-width="0.99905" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M1 5.99609H10.9905" stroke="#99A1AF" stroke-width="0.99905" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_623_1016">
                                        <rect width="11.9886" height="11.9886" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            {sponsor.sponsorUrl}
                        </div>

                        {!!sponsor.code && (
                            <>
                                <div className="sponsor-label">
                                    Promo Code
                                </div>

                                <div className="sponsor-code">
                                    {sponsor.code}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
    return (
        <div className="sponsor-card">
            {onRemove ? (
                <button className="sponsor-remove" onClick={() => onRemove(sponsor.id)}>
                    {'\u00D7'}
                </button>
            ) : null}
            {sponsor.type == 'Banner' ? (
                <img src={sponsor.mediaUrl ? process.env.REACT_APP_MEDIA_URL + sponsor.mediaUrl : placeholderImage} alt={sponsor.name} />
            ) : (
                <video src={process.env.REACT_APP_MEDIA_URL + sponsor.mediaUrl} controls />
            )}
            <div className="sponsor-info">
                <div className="sponsor-type">Sponsor {sponsor.type}</div>
                <div className="sponsor-name">{sponsor.name}</div>
            </div>
        </div>
    );
}

export default SponsorCard;